export const config = {
  apiGateway: {
    baseUrl: import.meta.env.VITE_API_GATEWAY_URL || 'http://localhost:8000/api/v1',
    timeout: 30000,
  },
  auth: {
    accessTokenKey: 'admin_access_token',
    refreshTokenKey: 'admin_refresh_token',
    tokenRefreshThreshold: 5 * 60 * 1000, // 5 minutes
  },
  app: {
    name: 'BID Admin Portal',
    version: import.meta.env.PACKAGE_VERSION || '1.0.0',
    environment: import.meta.env.MODE || 'development',
  },
  features: {
    enableImpersonation: import.meta.env.VITE_FEATURE_IMPERSONATION === 'true',
    enableBulkActions: import.meta.env.VITE_FEATURE_BULK_ACTIONS === 'true',
    enableAdvancedAnalytics: import.meta.env.VITE_FEATURE_ANALYTICS === 'true',
    maxBulkOperationSize: parseInt(import.meta.env.VITE_MAX_BULK_SIZE || '100'),
  },
}
